import { Flex, Text } from '@chakra-ui/layout';
import { Icon } from '@chakra-ui/react';
import { ReactNode } from 'react';

type TProps = { children: ReactNode; icon?: any };

const Title = ({ children, icon }: TProps) => (
    <Flex color="gray.900" alignItems="center" gap="8px">
        {icon && <Icon as={icon} width="16px" height="16px" color="inherit" />}
        <Text fontSize="md" fontWeight="700">
            {children}
        </Text>
    </Flex>
);

export default Title;
